<div *ngFor="let option of options">
  <input
    type="checkbox"
    [id]="option.value"
    [value]="option.value"
    [checked]="selectedValues.includes(option.value)"
    (change)="toggleCheckbox(option.value)"
  />
  <label [for]="option.value">{{ option.label }}</label>
</div>
